// extracted by mini-css-extract-plugin
export default {"productDescription":"v_-z","featuredDescription":"w_-z","description":"x_-z","more":"y_-z","descriptionSku":"z_-z"};